<template>
  <div class="copyright">
    <p>
      <a
        href="https://beian.miit.gov.cn/"
        :style="{ color: color }"
      >{{ content.content }}</a>
    </p>
    <p>
      <span>公司地址: {{ content.address }}</span>&nbsp;&nbsp;
      <span>电话: {{ content.phone }}</span>
    </p>
  </div>
</template>
<script>
import { getFooter } from "@/api"
export default {
  props: {
    color: String,
    default: () => '#fff'
  },
  data () {
    return {
      content: {}
    }
  },
  methods: {
    async getFooter () {
      const result = await getFooter()
      this.content = result.data.data
    }
  },
  created () {
    this.getFooter()
  },
}

</script>
<style lang="scss" scoped>
.copyright {
  font-size: 16px;
  text-align: center;

  a {
    color: #fff;
  }

  p {
    margin: 5px;
  }
}
</style>